export default "__VITE_ASSET__ccd3fe65__"